module.exports = "\n<h1>{{memvm.headerText}}</h1>\n<div class=\"row\">\n  <div class=\"col-xs-8\">\n    <div gt-form=\"\"></div>\n  </div>\n</div>\n<hr/>";